// appEditDetail namespace — EditDetail.tsx (logged-in render-job detail page).
// Keys mirror en/appEditDetail.ts exactly. EXACT current Polish strings, verbatim.
// Render currency UI = "gemy".
export const appEditDetail = {
  loading: 'Ładowanie…',
  error: { title: 'Nie udało się wczytać edita.' },
  errorCode: 'edit-{status}',
  notFound: {
    title: 'Nie znaleziono edita',
    body: 'Ten edit nie istnieje lub nie masz do niego dostępu.',
    back: 'Wróć do Editów',
  },
  // R5 (reguła 30): trzy słowa stanu. Kolejka i render to jedno „w kolejce”.
  status: {
    ready: 'gotowy',
    failed: 'błąd',
    rendering: 'w kolejce',
  },
  // Okruszek „Edity / nazwa serii / edit N" — nigdy „Biblioteka" o wynikach (słownik LOCKED).
  crumb: {
    library: 'Edity',
    current: 'Edit',
    edit: 'edit {n}',
  },
  // Tytuł strony = nazwa serii + numer editu (decyzja 3); identyfikator wyłącznie jako chip do skopiowania.
  title: '{series} · edit {n}',
  copyId: 'Kopiuj identyfikator',
  copied: 'Skopiowano identyfikator.',
  actions: {
    download: 'Pobierz MP4',
    reRender: 'Ponów',
    delete: 'Usuń',
    deleteFailed: 'Nie udało się usunąć edita.',
  },
  stage: {
    failed: 'Render się nie dokończył',
  },
  deleteDialog: {
    title: 'Usunąć edit?',
    confirm: 'Usuń edit',
    cancel: 'Anuluj',
  },
  toast: {
    retried: 'Ponowiono edit',
    ready: 'Nowy edit gotowy.',
    failed: 'Błąd renderu.',
    deleted: 'Edit usunięty.',
  },
  retry: {
    confirmTitle: 'Ponowić edit?',
    confirmBody: 'Nowy render losuje klipy od nowa.',
    cost: 'Koszt',
    have: 'Masz',
    remain: 'Zostanie',
    costFormula: '1 edit ×',
    cancel: 'Anuluj',
    close: 'Zamknij',
    dismiss: 'Zamknij okno',
    topUp: 'Doładuj tokeny',
    // R5 (zasada 8, artboard 08c): tytuł i TABELA Koszt / Masz. Klucz `noGemsBody`
    // („Masz {balance}, potrzeba {cost}. Brakuje {missing}.”) UMARŁ — trzecia liczba
    // była odejmowaniem dwóch pierwszych, a zdanie mówiło to, co tabela pokazuje.
    noGemsTitle: 'Za mało tokenów',
    refreshingBalance: 'Odświeżanie salda…',
    balanceUnavailable: 'Nie udało się potwierdzić aktualnego salda.',
    busyTitle: 'Za dużo renderów naraz',
    busyBody: 'Render nie ruszył, saldo bez zmian.',
    tryAgain: 'Spróbuj ponownie',
    progressTitle: 'Render w toku',
    pollTitle: 'Nie udało się sprawdzić renderu',
    pollBody: 'Nie udało się pobrać aktualnego postępu.',
    // `doneBody` („Nowy edit {n} jest gotowy.”) UMARŁ: powtarzał tytuł innymi słowami
    // (sesja 31 R5, punkt 5).
    doneTitle: 'Edit gotowy',
    facts: 'Długość i rozmiar',
    series: 'Seria',
    failedTitle: 'Błąd renderu',
    requestTitle: 'Nie udało się uruchomić renderu',
    requestUnknown: 'Nie udało się sprawdzić, czy render ruszył.',
    requestInvalid: 'Te ustawienia nie mogą uruchomić renderu.',
    requestPackUnavailable: 'Paczka klipów jest niedostępna; wybierz inną w Generatorze.',
    requestCode: 'retry-{code}',
  },
}
